import { render, staticRenderFns } from "./LogoWhatNotToDoSection2.vue?vue&type=template&id=512fdf7d"
import script from "./LogoWhatNotToDoSection2.vue?vue&type=script&lang=ts"
export * from "./LogoWhatNotToDoSection2.vue?vue&type=script&lang=ts"
import style0 from "./LogoWhatNotToDoSection2.vue?vue&type=style&index=0&id=512fdf7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports